<ion-card [class.select-group-v2]="isV2()">
	<ion-card-header>
		<ion-card-title>
			{{ element.translatedText }}
		</ion-card-title>

		@if (element.translatedDescription) {
			<ion-card-subtitle [innerHtml]="element.translatedDescription"></ion-card-subtitle>
		}
	</ion-card-header>

	<ion-card-content>
		<app-reference-images [images]="element.images"></app-reference-images>
	</ion-card-content>
	<ion-footer>
		<app-documentation [documentation]="element.documentation" [v2]="isV2()"></app-documentation>
	</ion-footer>
</ion-card>
